import { useAuthToggles } from './useAuthToggles';

export interface UseEnableSankhyaMenuResult {
  enableSankhyaMenu: boolean;
  isLoading: boolean;
}

export const useEnableSankhyaMenu = (authUrl: string): UseEnableSankhyaMenuResult => {
  const { data, isLoading } = useAuthToggles(authUrl);

  const enableSankhyaMenu = data?.enable_sankhya_menu ?? false;

  return { enableSankhyaMenu, isLoading };
};
